import React, { useState } from "react"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import { flatMap } from "lodash"

const ModalDesactivate = (props) => {
  const [loading, setLoading] = useState(false)

  const save = async () => {
    setLoading(true)
    try {
      const result = await fetchGlobalApi({
        method: "DELETE",
        endpoint: "employees/teamleader/user",
        data: {
          employees: flatMap(props.usersSelected, (item) => {
            return { id_user: item.user_id }
          }),
        },
      })
      setLoading(false)
      returnMessage(result)
      props.onFinish(true)
    } catch (error) {
      returnMessage(error)
    }
    setLoading(false)
  }

  const header = () => {
    const userSelecteds = props.usersSelected
    if (userSelecteds.length === 1) {
      return (
        <div>
          <b className="component-deletesimple__title">
            ¿Estás seguro de que deseas desactivar como usuario al <br /> líder{" "}
            {userSelecteds[0].first_name} {userSelecteds[0].last_name}?
          </b>
          <p style={{ marginTop: 12 }}>
            Esta acción hará que el colaborador ya no pueda ingresar al sistema.
          </p>
        </div>
      )
    }
    return (
      <div>
        <b className="component-deletesimple__title">
          ¿Estás seguro de que deseas desactivar como usuarios a <br /> los
          líderes seleccionados?
        </b>

        <span
          style={{
            display: "block",
            marginTop: 12,
            fontSize: 12,
            fontWeight: "normal",
          }}
          className="color-gray-low">
          Líderes a desactivar: <b>{userSelecteds.length}</b>
        </span>

        <p style={{ marginTop: 12 }}>
          Esta acción hará que los colaboradores ya no puedan ingresar al
          sistema como usuarios.
        </p>
      </div>
    )
  }

  return (
    <ModalCustom
      onCancel={() => props.onCancel()}
      onOk={save}
      modalOpen={props.open}
      showFooter
      isLoadingButton={loading}
      okType="danger"
      textButton="Desactivar">
      <div className="component-deletesimple">
        <img src={alertSvg} className="alertIcon" />
        <div className="component-deletesimple__description">{header()}</div>
      </div>
    </ModalCustom>
  )
}

ModalDesactivate.defaultProps = { onCancel: () => {} }

export default ModalDesactivate
